import { SkeletonLoading } from "../../../../../../components/Skeleton";
import { ModalSkeletonContainer } from "./ModalSkeleton.styles";

type MdoalSkeletonProps = {
  isPinnedGraph?: boolean;
  width?: number | string;
};

export function ModalSkeleton({ isPinnedGraph, width }: MdoalSkeletonProps) {
  // EN-5088: a pinned graph always fills the pinned tile, so its skeleton must
  // too. The sections pass the fixed modal chart widths (968/834/664/550) which
  // ignore isPinnedGraph, leaving the grey area far narrower than the chart it
  // stands in for — so the pinned case overrides them here, in one place.
  const containerWidth = isPinnedGraph ? "100%" : width;

  return (
    <ModalSkeletonContainer
      isPinnedGraph={isPinnedGraph}
      style={{ width: containerWidth }}
    >
      <SkeletonLoading width="120px" height="22px" />

      <div
        style={{
          marginTop: "4px",
          marginBottom: "2px",
        }}
      >
        <SkeletonLoading height="16px" width="180px" />
      </div>

      <SkeletonLoading height="22px" width="380px" />

      <div style={{ marginTop: "28px", width: "100%" }}>
        <SkeletonLoading
          height={isPinnedGraph ? "448px" : "480px"}
          width={isPinnedGraph ? "100%" : "95%"}
        />
      </div>
    </ModalSkeletonContainer>
  );
}

export function ModalSkeletonMobile() {
  return (
    <ModalSkeletonContainer>
      <SkeletonLoading width="220px" height="20px" />
      <br />
      <SkeletonLoading width="100px" height="22px" />

      <div
        style={{
          marginTop: "4px",
          marginBottom: "2px",
        }}
      >
        <SkeletonLoading height="16px" width="180px" />
      </div>

      <SkeletonLoading height="22px" width="280px" />

      <div style={{ marginTop: "28px" }}>
        <SkeletonLoading height="480px" width="95%" />
      </div>
    </ModalSkeletonContainer>
  );
}
